import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
export const deleteUser = async (id) => {
  try {
    const response = await apiClient.post(`/users/deleteUser/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
